import { ConsoleHeaderSelect } from '../../../components/shared/console/ConsoleHeaderSelect';
import type { ConsoleHeaderSelectOption } from '../../../components/shared/console/ConsoleHeaderSelect';

export type FraudMode = 'shadow' | 'enforcing';

const MODE_OPTIONS: ConsoleHeaderSelectOption[] = [
  { value: 'shadow', label: 'Shadow' },
  { value: 'enforcing', label: 'Enforcing' },
];

type FraudModeSelectProps = {
  value: FraudMode;
  onChange: (value: FraudMode) => void;
  disabled?: boolean;
};

export default function FraudModeSelect({ value, onChange, disabled }: FraudModeSelectProps) {
  return (
    <ConsoleHeaderSelect
      value={value}
      options={MODE_OPTIONS}
      onChange={(next) => onChange(next as FraudMode)}
      disabled={disabled}
      aria-label="Enforcement mode"
      minWidthClass="min-w-[8.75rem]"
    />
  );
}
